import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

export type XpButtonVariant = 'outline' | 'solid' | 'soft' | 'text' | 'icon';

@Component({
	selector: 'button[xpButton]',
	standalone: true,
	template: '<ng-content></ng-content>',
	styleUrls: ['./xp-button.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpButtonComponent {
	variant = input<XpButtonVariant>('outline');

	@HostBinding('attr.data-ui-variant')
	get variantAttribute(): XpButtonVariant {
		return this.variant();
	}
}
